import { render, staticRenderFns } from "./editorToolSettingsPopover.vue?vue&type=template&id=0fc2adfa&scoped=true&"
import script from "./editorToolSettingsPopover.vue?vue&type=script&lang=js&"
export * from "./editorToolSettingsPopover.vue?vue&type=script&lang=js&"
import style0 from "./editorToolSettingsPopover.vue?vue&type=style&index=0&id=0fc2adfa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc2adfa",
  null
  
)

export default component.exports